import React from 'react';
import type { Dayjs } from 'dayjs';
import type { WeddingDateVariantProps } from '../types';
import { WeddingDateDisplayFormatEnum } from '../../../../../../../util/websiteDateUtil';
import { To, CustomDateMessage, RangeDate } from './WeddingDateHorizontal.styles';

const WeddingDateHorizontal = ({ websiteDate }: WeddingDateVariantProps): JSX.Element => {
  const renderDate = (d?: Dayjs) => (
    <h3>
      <span className="month">{d?.format('MMMM')}</span>
      <span className="day">{d?.format('D')}</span>
      <span className="year">{d?.format('YYYY')}</span>
    </h3>
  );

  const renderDateFormat = (): React.ReactNode => {
    if (websiteDate.displayFormat === WeddingDateDisplayFormatEnum.CUSTOM) {
      return <CustomDateMessage>{websiteDate.customDateMessage}</CustomDateMessage>;
    }
    if (websiteDate.displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
      const { weddingDateRangeStart, weddingDateRangeEnd } = websiteDate || {};
      return (
        <>
          <RangeDate variant="start">{renderDate(weddingDateRangeStart)}</RangeDate>
          <To className="on">to</To>
          <RangeDate variant="end">{renderDate(weddingDateRangeEnd)}</RangeDate>
        </>
      );
    }
    return renderDate(websiteDate?.weddingDate);
  };

  return (
    <div className="date">
      <span>
        {websiteDate.displayFormat !== WeddingDateDisplayFormatEnum.CUSTOM && (
          <h4 className="on">on</h4>
        )}
        {renderDateFormat()}
      </span>
    </div>
  );
};

export default WeddingDateHorizontal;
